import styled from "styled-components";
import { applyStyleModifiers } from "styled-components-modifiers";

const modifiers = {
  roundedBorder: () => ({
    styles: `
      border-radius: 1rem;
    `,
  }),
};

const ImageWrapperStyled = styled.div.attrs({
  className: "ImageWrapper",
})`
  width: 100%;
  height: auto;
  display: block;
  overflow: hidden;
  position: relative;
  ${applyStyleModifiers(modifiers)};

  img {
    width: 100%;
    display: block;
  }
`;

export default ImageWrapperStyled;
